// extracted by mini-css-extract-plugin
var _1 = "BaseNavigationButton_disabled__f3037";
var _2 = "BaseNavigationButton_icon__42c8e";
var _3 = "BaseNavigationButton_iconLeft__44b3d";
var _4 = "BaseNavigationButton_iconRight__b7182";
var _5 = "BaseNavigationButton_left__6c5fb";
var _6 = "BaseNavigationButton_right__76999";
var _7 = "BaseNavigationButton_root__60902";
export { _1 as "disabled", _2 as "icon", _3 as "iconLeft", _4 as "iconRight", _5 as "left", _6 as "right", _7 as "root" }
